
<script setup lang="ts">
const store = useStore()
const { mainMenu } = storeToRefs(store)
const menuData = ref(mainMenu.value)
const menuActive = ref<any>()
const level = ref(0)
const menuLevel = ref<any>({})
const load = (menu: any, index: number, levelData: number) => {
  menuData.value = menu.children
  menuActive.value = menu
  level.value += levelData
  menuLevel.value[level.value - 1] = index
}
const back = () => {
  if (level.value === 1) {
    menuData.value = mainMenu.value
  } else if (level.value === 2) {
    menuActive.value = mainMenu.value[menuLevel.value[0]]
    menuData.value = menuActive.value.children
  }
  level.value -= 1
}
interface Link {
  extensions: {
    categoryUrlData: {
      linkType: string
      urlPrefix: string
      url: string
    }
  },
  externalLink: string
}
const getLink = ({ extensions: { categoryUrlData: { linkType, urlPrefix, url } }, externalLink }: Link) => {
  return linkType === 'external' ? externalLink : `/${urlPrefix}/${url}`
}
const getTargetLink = (target: boolean) => {
  return target ? '_blank' : null
}
</script>

<template>
  <div v-if="level !== 0" class="px-[10px]">
    <div class="flex justify-between py-[20px]" @click.prevent="back()">
      <span class="text-24 font-bold">{{ menuActive.name }}</span>
      <span class="flex items-center gap-[10px]">
        <i class="icon-arrow-menu rotate-180" />
        <span class="uppercase">wróć</span>
      </span>
    </div>
    <div @click="store.getModal(false, null)">
      <NuxtLink v-if="level === 1" :to="getLink(menuActive)" :target="getTargetLink(menuActive.extensions.categoryUrlData.linkNewTab)" class="flex justify-between bg-secondary text-white rounded-[5px] p-[20px]">
        <span class="text-16 font-bold">Pokaż {{ menuActive.name }}</span>
        <i class="icon-arrow-menu" />
      </NuxtLink>
    </div>
  </div>
  <ul class="text-14 p-[20px]">
    <li v-for="(link_1, index) in menuData" :key="link_1.id" class="border-b border-solid border-gray-400 p-[10px]">
      <span v-if="level === 0">
        <span v-if="link_1.children.length" class="flex justify-between items-center text-menu" @click.prevent="load(link_1, index, 1)">
          <span>{{ link_1.name }}</span>
          <i class="icon-arrow-menu" />
        </span>
        <NuxtLink v-else :to="getLink(link_1)" :target="getTargetLink(link_1.extensions.categoryUrlData.linkNewTab)" class="flex text-menu">
          <span class="w-full" @click="store.getModal(false, null)">{{ link_1.name }}</span>
        </NuxtLink>
      </span>
      <span v-else>
        <NuxtLink :to="getLink(link_1)" :target="getTargetLink(link_1.extensions.categoryUrlData.linkNewTab)" class="flex justify-between items-center text-menu">
          <span class="w-full" @click="store.getModal(false, null)">{{ link_1.name }}</span>
          <i v-if="link_1.children.length" class="icon-arrow-menu" @click.prevent="load(link_1, index, 1)" />
        </NuxtLink>
      </span>
    </li>
  </ul>
</template>
